<template>
  <div class="container">
    <div class="mb-3">
      <h2 class="text-center">{{ detailRole?.name }} Role Menu</h2>
    </div>
    <tree :config="config" :nodes="nodes">
      <template #before-input="props">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            :value="props.node.status"
            :checked="props.node.status"
            :id="`checkbox` + props.node.id"
            @click="
              handleCheckedAction(
                props.node.permission_code,
                $event.target.checked
              )
            "
          />
        </div>
      </template>
    </tree>
  </div>
</template>

<script>
import { toast } from "vue-sonner";
import { useMenuRole } from "@/stores/master/menu-role";
import { useRoleStore } from "@/stores/master/role";
import { collectLevelOneIds, convertToTreeFormat } from "@/utils/helper";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import treeview from "vue3-treeview";
import "vue3-treeview/dist/style.css";

export default {
  components: {
    tree: treeview,
  },
  setup() {
    const menuRoleStore = useMenuRole();
    const roleStore = useRoleStore();
    const nodes = ref({});
    const modalShow = ref(false);
    const router = useRouter();
    const detailRole = ref({});

    const config = {
      roots: ["id1"],
      openedIcon: {
        type: "img",
        height: 20,
        width: 20,
        src: "https://n00ts.github.io/vue3-treeview/minus.png",
      },
      closedIcon: {
        type: "img",
        height: 20,
        width: 20,
        src: "https://n00ts.github.io/vue3-treeview/add.png",
      },
    };

    const loadNodes = async () => {
      try {
        const response = await menuRoleStore.dispatchGetAll(
          router.currentRoute.value.params.id
        );
        const data = convertToTreeFormat(await menuRoleStore.menus.data);
        const level1 = collectLevelOneIds(await menuRoleStore.menus.data);
        nodes.value = data;
        config.roots = level1;
      } catch (error) {
        console.error("Failed to load nodes:", error);
      }
    };

    const loadDetailRole = async () => {
      const { success, message } = await roleStore.dispatchDetail(
        router.currentRoute.value.params.id
      );
      if (success) {
        detailRole.value = await roleStore.role.data;
      }
    };

    onMounted(() => {
      loadNodes();
      loadDetailRole();
    });

    const handleCheckedAction = async (permission_code, current) => {
      var payload = {};
      payload.role_id = router.currentRoute.value.params.id;
      payload.permission_code = permission_code;
      payload.status = current;
      const { success, message } = await menuRoleStore.dispatchUpdate(payload);
      if (success) {
        toast.success("Menu Role Successfully Updated");
      } else {
        toast.error("Menu Role Failed Updated");
      }
    };

    return {
      detailRole,
      nodes,
      config,
      modalShow,
      handleCheckedAction,
    };
  },
};
</script>
